<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="assign-article-category-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Assign Category
            </h4>
          </div>

          <div class="modal-body">
            <SelectFormGroup
                v-model="data.content_article_category_id"
                name="content_article_category_id"
                label="Article Category"
                :error="(errors.content_article_category_id || [])[0]"
                :options="contentArticleCategoryOptions"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

export default {
  components: {SelectFormGroup},

  mixins: [Errors],

  props: {
    selected: {
      type: Array
    },

    contentArticleCategories: {
      type: Array
    }
  },

  data() {
    return {
      data: {}
    }
  },

  mounted() {
    this.listenForClose()
  },

  computed: {
    contentArticleCategoryOptions() {
      return this.contentArticleCategories.map(contentArticleCategory => {
        return {
          value: contentArticleCategory.id,
          label: contentArticleCategory.attributes.name
        }
      })
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      if (!this.data.content_article_category_id) {
        this.errors = {
          content_article_category_id: ['The content article category field is required.']
        }

        return
      }

      Promise
          .all(this.selected.map(contentArticle => http.put('/api/v2/content-articles/' + contentArticle.id, {
            ...contentArticle.attributes,
            ...this.data
          })))
          .then(responses => {
            notify.success('The category was assigned')

            responses.map(response => this.$emit('updated', response.data.data))

            $(this.$el).modal('hide')
          })
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
